import {get, post, del, patch} from "../api"
import * as url from "../url"

const apiGetInboxFilter = data => {
  return get(url.API_FILES + "filter/", data.history)
}

const apiPostInboxSegments = data => {
  return post(url.API_FILES + "segments/", data.history, data.data)
}

export {
  apiGetInboxFilter,
  apiPostInboxSegments,
}
